import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommissionPromoterAdditional } from 'src/oldApp/model/commission-promoter-additional';

@Injectable({
  providedIn: 'root'
})
export class CommissionFisofoService {

  private url:string;

  constructor(private http:HttpClient) {
    this.url=environment.services_url;
  }

  getCommissions=()=> {
    return this.http.get(`${this.url}/CommissionFisofo/getCommissions`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollect=(simulateDateIni:string, simulateDateFin:string, simulateId:number)=> {
    return this.http.get(`${this.url}/CommissionFisofo/getCommissionCollect?simulateDateIni=${simulateDateIni}&simulateDateFin=${simulateDateFin}&simulateId=${simulateId}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionCollectApplied=(simulateDateIni:string, simulateDateFin:string)=> {
    return this.http.get(`${this.url}/CommissionFisofo/getCommissionCollectApplied?simulateDateIni=${simulateDateIni}&simulateDateFin=${simulateDateFin}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissionGroups=()=> {
    return this.http.get(`${this.url}/CommissionFisofo/getCommissionGroups`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getEmployeeJobs=()=> {
    return this.http.get(`${this.url}/CommissionFisofo/getEmployeeJobs`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getProducts=()=> {
    return this.http.get(`${this.url}/CommissionFisofo/getFinancingTypes`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getAfiliatesByProduct=(listIds:number[])=> {
    return this.http.post(`${this.url}/CommissionFisofo/getAfiliatesByFinancingType`, listIds)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getPaymentTermsByAfiliate=(listIds:number[])=> {
    return this.http.post(`${this.url}/CommissionFisofo/getPaymentTermsByAfiliate`, listIds)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  delete=(model:CommissionPromoterAdditional)=> {
    return this.http.post(`${this.url}/CommissionFisofo/delete`, model)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveUpdate=(model:CommissionPromoterAdditional)=> {
    return this.http.post(`${this.url}/CommissionFisofo/saveUpdate`, model)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveUpdateNew=(model:any)=> {
    return this.http.post(`${this.url}/CommissionFisofo/saveUpdateNew`, model)
      .pipe(
        map((resp:any)=> resp)
      );
  }

}
